import {MutationTree} from 'vuex';

const mutations: MutationTree<IssueTrackerState> = {

};

export default mutations;
